import React from 'react';
import { IconProps } from '../IconProps';
const SvgAppleFruit = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M26.2288 10.1445C23.5949 8.05138 20.7495 8.61513 18.466 9.06652C16.6891 9.41887 15.3179 9.42267 13.5924 9.04557C11.3907 8.56562 8.65776 7.96948 5.78385 10.1197C1.62439 13.2299 1.49107 20.5949 5.48103 26.8838C8.89773 32.2738 12.6344 31.5786 14.8665 31.1672C15.7445 31.0034 16.2434 31.0053 17.1195 31.1672C17.7956 31.2929 18.6108 31.4453 19.5116 31.4453C21.5875 31.4453 24.1243 30.6435 26.5069 26.8838C30.613 20.4007 29.6569 12.8604 26.2288 10.1445Z"
      fill="#200C05"
    />
    <path
      d="M20.647 1.44531C21.1727 1.44531 21.5993 1.87194 21.5993 2.3976C21.5993 5.02591 19.4662 7.15904 16.838 7.15904C16.3124 7.15904 15.8857 6.73241 15.8857 6.20675C15.8857 3.57844 18.0188 1.44531 20.647 1.44531Z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgAppleFruit;
